import { Injectable } from '@angular/core';
import { SubscriptionLike as ISubscription } from 'rxjs';

@Injectable()
export class LMFieldSubscriptionService {

  private fieldSubscriptionsArray: Array<FieldSubscription> = [];

  constructor() {  }

  add(key: string, newSubscription?: ISubscription): void {
    if (!newSubscription && this.fieldSubscriptionsArray[key]) {
      // no new subscription passed in, and a subscription already exists in the array. Increment the total
      // number
      this.fieldSubscriptionsArray[key].totalNumber++;

    } else if (newSubscription && this.fieldSubscriptionsArray[key]) {
      // the subscription already existed, but passed in a new subscription. Since we want a one subscription
      // to many fields, unsubscribe from the previously stored subscription and put in new
      this.fieldSubscriptionsArray[key].subscription.unsubscribe();
      this.fieldSubscriptionsArray[key].subscription = newSubscription;

    } else if (newSubscription && !this.fieldSubscriptionsArray[key]) {
      // subscription doesn't exist in the array, so add it
      this.fieldSubscriptionsArray[key] = {subscription: newSubscription, totalNumber: 1};
    }
    // fall thru would be that no subscription was handed in, and there is no entry in the
    // array for that key. in this case we are no-oping
  }

  remove(key: string): void {
    if (this.fieldSubscriptionsArray[key] ) {
      this.fieldSubscriptionsArray[key].totalNumber--;

      if (this.fieldSubscriptionsArray[key].totalNumber === 0) {
        this.fieldSubscriptionsArray[key].subscription.unsubscribe();
        delete this.fieldSubscriptionsArray[key];
      }
    }
  }

  subscriptionAlreadyExists(key: string): boolean {
    return (this.fieldSubscriptionsArray[key] !== undefined);
  }
}

type FieldSubscription = { subscription: ISubscription, totalNumber: number};
